import { Avatar, Dropdown, Layout, Menu, Space, Tag } from '@arco-design/web-react';
import {
  IconDashboard,
  IconIdcard,
  IconNotification,
  IconExclamationCircle,
  IconBug,
  IconExperiment,
  IconPoweroff,
  IconUserGroup,
  IconUser,
} from '@arco-design/web-react/icon';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAdminAuthStore } from '@/store/authStore';

const { Sider, Header, Content } = Layout;

const menuItems: Array<{ key: string; label: string; icon: JSX.Element }> = [
  { key: '/dashboard', label: '工作台', icon: <IconDashboard /> },
  { key: '/customers', label: '客户中心', icon: <IconUserGroup /> },
  { key: '/cards', label: '卡片管理', icon: <IconIdcard /> },
  { key: '/webhooks', label: 'Webhook 收件箱', icon: <IconNotification /> },
  { key: '/upstream-errors', label: '上游错误日志', icon: <IconExclamationCircle /> },
  { key: '/upstream-comm', label: '上游通讯调试', icon: <IconBug /> },
  { key: '/sandbox/simulate', label: '沙箱模拟交易', icon: <IconExperiment /> },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { profile, logout } = useAdminAuthStore();

  const selectedKey =
    menuItems.find((m) => location.pathname.startsWith(m.key))?.key ?? '/dashboard';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider width={220} style={{ background: 'var(--admin-brand)' }}>
        <div
          style={{
            height: 56,
            display: 'flex',
            alignItems: 'center',
            padding: '0 20px',
            color: '#fff',
            fontSize: 18,
            fontWeight: 600,
            letterSpacing: 1,
            borderBottom: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          UP·CARD ADMIN
        </div>
        <Menu
          theme="dark"
          selectedKeys={[selectedKey]}
          onClickMenuItem={(key) => navigate(key)}
          style={{ background: 'transparent' }}
        >
          {menuItems.map((item) => (
            <Menu.Item key={item.key}>
              <Space>
                {item.icon}
                {item.label}
              </Space>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>

      <Layout>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: '#fff',
            height: 56,
            padding: '0 24px',
            borderBottom: '1px solid var(--admin-border-light)',
          }}
        >
          <Space size="large">
            <Tag color="green" bordered>
              管理端 · {import.meta.env.MODE}
            </Tag>
            <span style={{ color: 'var(--admin-text-secondary)' }}>
              所有写操作均会写入审计日志
            </span>
          </Space>
          <Dropdown
            droplist={
              <Menu
                onClickMenuItem={async (key) => {
                  if (key === 'logout') {
                    await logout();
                    navigate('/login');
                  }
                }}
              >
                <Menu.Item key="logout">
                  <IconPoweroff /> 退出登录
                </Menu.Item>
              </Menu>
            }
          >
            <Space style={{ cursor: 'pointer' }}>
              <Avatar size={32} style={{ backgroundColor: 'var(--admin-brand-2)' }}>
                <IconUser />
              </Avatar>
              <span>{profile?.username ?? 'admin'}</span>
            </Space>
          </Dropdown>
        </Header>
        <Content style={{ background: 'var(--admin-bg-page)' }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
